import { render } from "./ProjectStages.vue?vue&type=template&id=5eb3dc23&scoped=true"
import script from "./ProjectStages.vue?vue&type=script&lang=js"
export * from "./ProjectStages.vue?vue&type=script&lang=js"

import "./ProjectStages.vue?vue&type=style&index=0&id=5eb3dc23&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb3dc23"]])

export default __exports__